/* global axios */
import ApiClient from './ApiClient';

class TalkviaInventoryMovementsAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_movements', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { talkvia_inventory_movement: data });
  }
}

export default new TalkviaInventoryMovementsAPI();
